import { useEffect, useState } from "react";

// True when the element at the viewport probe point sits inside a [data-tone="light"] section.
export default function useLightTone(probeY) {
  const [light, setLight] = useState(false);

  useEffect(() => {
    let raf = null;
    const check = () => {
      raf = null;
      const y = typeof probeY === "function" ? probeY() : probeY;
      const el = document.elementFromPoint(Math.floor(window.innerWidth / 2), y);
      setLight(Boolean(el && el.closest('[data-tone="light"]')));
    };
    const schedule = () => {
      if (!raf) raf = requestAnimationFrame(check);
    };
    check();
    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule);
    return () => {
      window.removeEventListener("scroll", schedule);
      window.removeEventListener("resize", schedule);
      if (raf) cancelAnimationFrame(raf);
    };
  }, [probeY]);

  return light;
}
